import { styled } from '@mui/material/styles';

export const Audio = styled('audio')`
  min-width: 32rem;

  &::-webkit-media-controls-panel {
    background-color: ${({ theme }) => theme.palette.common.white};
  }
`;
